export default "<section class=\"col-lg-8 pt-lg-4 pb-4 mb-3\">\n</section>"